export default __webpack_public_path__ + "static/media/auth_sm.0d3b6c5e.jpg";